import { filenameFromResponse } from '@/shared/utils/download-blob.util';
import { BaseService } from '../base';
import type { PaymentReceipt } from './types';

export type * from './types';

/**
 * Comprovante público da parcela paga pelo link. A rota não exige login: o
 * token do endereço é a proteção.
 */
export class PaymentReceiptsService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  /** `notFound`: link inválido ou parcela inexistente — tentar de novo não adianta. */
  async getReceipt(token: string): Promise<{
    success: boolean;
    data?: PaymentReceipt;
    notFound?: boolean;
    error?: string;
  }> {
    try {
      const response = await this.get(
        `/portal/v1/payment-receipts/${encodeURIComponent(token)}`,
        {},
        this.customBaseUrl
      );
      if (response.status === 404) {
        return { success: false, notFound: true };
      }
      return await this.handleJsonResponse<PaymentReceipt>(response);
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erro de conexão',
      };
    }
  }

  /** PDF do comprovante. A API só gera com o pagamento confirmado. */
  async getReceiptPdf(
    token: string
  ): Promise<{ blob: Blob; filename: string }> {
    const response = await this.get(
      `/portal/v1/payment-receipts/${encodeURIComponent(token)}/pdf`,
      {},
      this.customBaseUrl
    );
    if (!response.ok) {
      throw new Error(
        'Não foi possível baixar o comprovante agora. Tente de novo em instantes.'
      );
    }
    return {
      blob: await response.blob(),
      filename: filenameFromResponse(response, 'comprovante-pagamento.pdf'),
    };
  }
}

export const paymentReceiptsService = new PaymentReceiptsService();
